import { alpha, Box, useTheme } from '@ltvco/refresh-lib/theme';

import { searchpal_persistent } from 'images';
import { CHATBOT_INTERACTION_TYPES } from 'routes/SearchPerson/SearchFilter/constants';

import { NotificationMessage } from './NotificationMessage';

export function SearchAssistantPersistantIcon({
  initialNotificationVisible,
  setInitialNotificationVisible,
  capitalizeFullName,
  setIsChatbotOpen,
}: {
  initialNotificationVisible: boolean;
  // eslint-disable-next-line no-unused-vars
  setInitialNotificationVisible: (visible: boolean) => void;
  capitalizeFullName: string;
  // eslint-disable-next-line no-unused-vars
  setIsChatbotOpen: (type: string) => void;
}) {
  const theme = useTheme();
  return (
    <Box
      sx={{
        position: 'fixed',
        bottom: 35,
        right: 25,
        zIndex: 1000,
        cursor: 'pointer',
        display: 'flex',
      }}
    >
      <Box
        sx={{
          width: '56px',
          height: '56px',
          transition: 'box-shadow 0.2s',
          '&:hover': {
            boxShadow: `5px ${alpha(
              theme.palette?.barChart?.contrastText,
              0.25
            )}`,
          },
        }}
        onClick={() => {
          setIsChatbotOpen(CHATBOT_INTERACTION_TYPES.OPEN);
          setInitialNotificationVisible(false);
        }}
      >
        <img src={searchpal_persistent} alt="Searchpal" />
      </Box>

      <NotificationMessage
        initialNotificationVisible={initialNotificationVisible}
        setInitialNotificationVisible={setInitialNotificationVisible}
        capitalizeFullName={capitalizeFullName}
        setIsChatbotOpen={setIsChatbotOpen}
      />
    </Box>
  );
}
